<template>
  <div>
    <span >
      <form @submit.prevent="checkFormValues($event)" action="https://www.paypal.com/cgi-bin/webscr" method="post">

          <!-- Identify your business so that you can collect the payments. -->
          <input type="hidden" name="business" value="matt@everythingcheeranddance.com"/>

          <!-- Specify a Subscribe button. -->
          <input type="hidden" name="cmd" value="_xclick-subscriptions"/>

          <!-- Identify the subscription. -->
          <input type="hidden" name="item_name" value="Small Listing"/>
          <input type="hidden" name="item_number" :value="listingId"/>

          <!-- Set the terms of the trial. -->
          <input type="hidden" name="currency_code" value="USD"/>

          <template v-if="threeMonthTrial == 'Y'">
            <input type="hidden" name="a1" value="0"/>
            <input type="hidden" name="p1" value="90"/>
            <input type="hidden" name="t1" value="D"/>
          </template>

          <!-- Set the terms of the regular subscription. -->
          <input type="hidden" name="a3" :value="amount"/>
          <input type="hidden" name="p3" value="1"/>
          <input type="hidden" name="t3" value="M"/>

          <!-- Set recurring payments until canceled. -->
          <input type="hidden" name="src" value="1"/>

          <!-- Display the payment button. -->
          <input type="image" name="submit"
          src="https://www.paypalobjects.com/en_US/i/btn/btn_subscribe_LG.gif"
          alt="Subscribe"/>


          <!-- return url -->
          <input type="hidden" name="return" value="https://app.everythingcheeranddance.com/account/listings"/>
           <input type="hidden" name="rm" value="2">


          <img alt="" width="1" height="1"
          src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" />
      </form>
    </span>
  </div>
</template>

<script>
import API from '@/API/API'
export default {
  name: "PayPal",
  components: {},
  props: {
    amount: {
      default: "3.95"
    },
    listingId: {
      default: ""
    }
  },
  data() {
    return {
      threeMonthTrial:0,
      api:API
    };
  },
  mounted() {
    this.getThreeMonthTrial()
  },
  methods: {
    checkFormValues(e) {
      this.$forceUpdate();
      setTimeout(() => {
        e.target.submit();
      },1000);
    },
    getThreeMonthTrial(){
      let self = this;
      this.api
      .getThreeMonthTrial()
      .then(function (res) {
        if (res.data) {
          let data = res.data
          if (!data.error) {
              self.threeMonthTrial = data.threeMonthTrial
          }
        }else{
        }
      })
      .catch(e => {
      })
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/PayPal.vue